import type { ChatItem } from '@couch/shared';

/** Tool names as people read them. */
const TOOL_LABELS: Readonly<Record<string, string>> = {
  list_machines: 'Looked at your machines', list_models: 'Looked at the installed models', search_nodes: 'Searched ComfyUI nodes',
  get_node: 'Read a node', get_workflow_guide: 'Read the workflow guide', search_workflow_templates: 'Searched ComfyUI templates',
  import_workflow: 'Imported a ComfyUI workflow', validate_workflow: 'Checked the workflow', create_workflow: 'Saved the workflow',
  update_workflow: 'Changed the workflow', run_workflow: 'Ran the workflow', get_run: 'Checked the run', get_image: 'Looked at the picture',
  install_model: 'Started a model download', list_downloads: 'Checked the downloads', install_node_pack: 'Asked to install custom nodes',
  search_node_packs: 'Searched custom nodes', find_node_packs_for: 'Looked for missing nodes', list_input_images: 'Looked at your pictures',
  upload_image: 'Put a picture on the machine', list_workflows: 'Looked at your workflows', get_workflow: 'Read a workflow', cancel_run: 'Stopped a run', run_batch: 'Ran it over several pictures', get_batch: 'Checked the pictures',
};

function ToolItem({ item }: { item: Extract<ChatItem, { kind: 'tool' }> }) {
  return (
    <li className={`chat-tool${item.isError ? ' chat-tool-error' : ''}`}>
      <details>
        <summary>{item.output === null ? '…' : item.isError ? '⚠' : '✓'} {TOOL_LABELS[item.name] ?? item.name}</summary>
        <p className="muted"><code>{item.name}</code> {item.input}</p>
        {item.output && <pre>{item.output}</pre>}
      </details>
      {item.image && <img src={item.image} alt="What Claude looked at" />}
    </li>
  );
}

/** The conversation: your messages right, Claude's left, its tool steps in between. */
export function ChatItems({ items }: { items: ChatItem[] }) {
  return (
    <ol className="chat-items" aria-label="Conversation">
      {items.map((item, i) => {
        if (item.kind === 'tool') return <ToolItem key={i} item={item} />;
        const side = item.role === 'user' ? 'chat-user' : 'chat-claude';
        return item.kind === 'text'
          ? <li key={i} className={`chat-bubble ${side}`}>{item.text}</li>
          : <li key={i} className={`chat-picture ${side}`}><img src={item.src} alt={item.role === 'user' ? 'Your picture' : 'A picture from Claude'} /></li>;
      })}
    </ol>
  );
}
